import { call, put, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from '../../api/request';
import {
  ACCESS_TOKEN_KEY,
  getStringFromStorageGenerator, REFRESH_TOKEN_KEY,
  removeStringFromStorageGenerator,
} from '../../utils/local-storage';
import {
  getLandingContentAction,
  landingAction,
  landingErrorAction,
  landingMeErrorAction,
  landingSuccessAction, setLandingAllDataFetchedAction,
  setLandingContentAction,
} from '../../store/customers/landing.store';
import { meAPI } from '../../api/provider/auth/auth-provider';
import { userSetDataAction, UserTypeVariant } from '../../store/user.store';
import { authenticatedCall } from '../../utils/authenticated-call';
import { getRoomsAction } from '../../store/customers/rooms-list.store';
import { servicesListAPI } from '../../api/provider/product/product-provider';

function* landingSaga() {

  let meResult: ApiResponse | null = null
  let userType: UserTypeVariant | null = null
  let navigationPage: string | null = null

  try {
    const token = getStringFromStorageGenerator(ACCESS_TOKEN_KEY)
    if (token) {
      meResult = yield authenticatedCall(meAPI)
      userType = meResult?.data.data.user_type
      yield put(userSetDataAction(meResult?.data.data))
      navigationPage = userType === 'Admin' ? '/admin/all-events' : '/customer/rooms'
      yield put(landingSuccessAction(navigationPage))
    }
  } catch (error: any) {
    removeStringFromStorageGenerator(ACCESS_TOKEN_KEY)
    removeStringFromStorageGenerator(REFRESH_TOKEN_KEY)
    yield put(landingMeErrorAction(error.localizedMessage))
  }
}

function* landingContentSaga() {
  // try {
  //     const servicesResponse: ApiResponse  = yield call(servicesListAPI);
  //     yield put(setLandingContentAction(servicesResponse.data.data))
  // } catch (error: any) {
  //   yield put(landingErrorAction(error.localizedMessage))
  // }

  try {
    yield put(getRoomsAction())
  } catch (error: any) {
    yield put(landingErrorAction(error.localizedMessage))
  }

  yield put(setLandingAllDataFetchedAction(true))
}

export function* landingSagas() {
  yield takeLatest(landingAction.type, landingSaga);
  yield takeLatest(getLandingContentAction.type, landingContentSaga);
}
